import endpoints from "../config/endpoints";
import api from "../config/axios";

export const GetAllNotifications = async (params) => {
  try {
    let query = new URLSearchParams(params).toString();
    const response = await api.get(`${endpoints.Notification.GetAllNotifications}?${query}`);

    return {
        data: response.data.data || [],
        pagination: {
            pageIndex: response.data.pageIndex,
            pageSize: response.data.pageSize,
            totalRecord: response.data.totalRecord,
        },
        status: response.data.status,
        statusCode: response.data.statusCode,
        message: response.data.message,
    };
  } catch (error) {
    console.error('Error fetching notifications:', error);
    return {
      data: { notificationList: [], totalUnread: 0 },
      status: false,
      statusCode: 500,
      message: 'Error fetching notifications',
    };
  }
}

export const MarkNotificationAsRead = async (notificationId, userId) => {
  try {
    const response = await api.put(
      `${endpoints.Notification.MarkNotificationAsRead}?notificationId=${notificationId}&userId=${userId}`
    );

    return {
      data: response.data.data,
      status: response.data.status,
      statusCode: response.data.statusCode,
      message: response.data.message,
    };
  } catch (error) {
    console.error('Error marking notification as read:', error);
    return {
      data: null,
      status: false,
      statusCode: 500,
      message: 'Error marking notification as read',
    };
  }
};

export const MarkAllNotificationsAsRead = async (userId, role = "Admin") => {
  try {
    var response = await api.put(`${endpoints.Notification.MarkAllNotificationsAsRead}?userId=${userId}&role=${role}`);
    return {
        data: response.data.data || [],
        status: response.data.status,
        statusCode: response.data.statusCode,
        message: response.data.message,
    };
  } catch (error) {
    console.error('Error marking all notifications as read:', error);
    return {
      data: [],
      status: false,
      statusCode: 500,
      message: 'Error marking all notifications as read',
    };
  }
}
  